// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RetentionType {
    ItemLevel = 0,
    SnapshotBased = 1
}
